export default function ManifestoSection() {
  return (
    <section className="relative bg-white px-4 md:px-6 py-24 md:py-32">
      <div className="max-w-[1140px] mx-auto flex flex-col items-center">
        <div className="mb-12 px-8 py-3 border border-foreground-900 rounded-full">
          <span className="font-label text-xs font-medium tracking-[0.12em] uppercase text-foreground-900">Philosophy</span>
        </div>

        <div className="text-center max-w-[860px] mx-auto">
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-light italic leading-[1.5] text-foreground-950">
            Engineering <span className="inline-flex items-center mx-1"><span className="w-5 h-5 md:w-7 md:h-7 rounded-full bg-accent-300/60 inline-block align-middle" /></span> excellence
            <br />
            is not a destination
            <span className="inline-flex items-center mx-1"><span className="w-4 h-4 md:w-5 md:h-5 bg-secondary-400 inline-block align-middle" style={{ clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)' }} /></span>
            &mdash; it is a
            <br />
            continuous practice
            <span className="inline-flex items-center mx-1"><span className="w-5 h-5 md:w-6 md:h-6 rounded-full border-2 border-primary-400 inline-block align-middle" /></span>
          </h2>
        </div>

        <div className="mt-16 max-w-[720px] text-center">
          <p className="font-body text-foreground-600 text-base md:text-lg leading-relaxed">
            Every system we design is built to last. We believe that great software emerges from disciplined thinking, rigorous standards, and an unwavering commitment to quality at every layer of the stack.
          </p>
        </div>
      </div>
    </section>
  );
}